import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';

interface GreyBoxProps {
  boxes: {
    title: string;
    text: string;
  }[];
}

export const GreyBox: React.FC<GreyBoxProps> = ({ boxes }) => {
  return (
    <div className="flex flex-col mb-2 bg-gray-100 pt-2 pb-8 pl-2  ">
      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className="flex p-8 gap-x-4 gap-y-8 flex-wrap justify-around w-full h-fit"
      >
        {boxes.map((box, index) => (
          <m.div
            variants={itemVariants}
            key={index}
            className="flex flex-col pt-5 gap-2 w-96  md:h-32"
          >
            <h3>{box.title}</h3>
            <p>{box.text}</p>
            {index !== boxes.length - 1 && (
              <div className=" bg-gray-200 w-full h-0.5 mt-5 md:mt-0 md:h-0 md:w-0"></div>
            )}
          </m.div>
        ))}
      </m.div>
    </div>
  );
};
